module.exports = __webpack_public_path__ + "media/images/close-popup-icon-43bdc9665e4df192f656bfb8801238af.svg";